var React = require('react');

function AngleDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.6015 16.3031L4.664 9.4218a.563.563 0 010-.7968l.9281-.9281a.563.563 0 01.797 0L12 13.2515l5.6109-5.5546a.563.563 0 01.7969 0l.9281.928a.563.563 0 010 .797l-6.9375 6.8812a.563.563 0 01-.7969 0z"}));
}

AngleDown.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = AngleDown;

AngleDown.default = AngleDown;
